import { StyleSheet } from 'react-native';
import { DynamicStyleSheet } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    height: 48,
  },
  tabWrapper: {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0,
    paddingVertical: 4,
    paddingHorizontal: 2,
  },
  tabContent: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: theme.colors.tabBarInactive,
  },
  textActive: {
    color: theme.colors.tabBarActive,
  },
  iconContainer: {
    position: 'relative',
  },
  badge: {
    position: 'absolute',
    top: -3,
    right: -6,
  },
  shadow: {
    ...Platform.select({
      web: {
        'box-shadow': '0px 0px 2px rgba(0, 0, 0, 0.08), 0px -1px 4px rgba(0, 0, 0, 0.06)',
      },
      ios: {
        borderTopWidth: StyleSheet.hairlineWidth,
        borderTopColor: theme.colors.separator,
      },
      android: {
        elevation: 4,
      },
    }),
  },
}));
